import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/pages/auth/auth.context";
import { useToast } from "@/hooks/use-toast";
import { UserPublicInfoDto } from "@/pages/admin/events/types";

// Define the type of the API response based on the Java class structure
interface UserDto {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  isApproved?: boolean;
  seniorityLevelId?: string;
  eligiblePositionIds?: string[];
  positionDocuments?: any[];
  emailNotifications?: boolean;
  smsNotifications?: boolean;
}

// Convert UserDto to UserPublicInfoDto
const mapUserDtoToPublicInfo = (user: UserDto): UserPublicInfoDto => ({
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  phoneNumber: user.phoneNumber,
});

export function useEmployeesList(enabled: boolean = true) {
  const { toast } = useToast();

  return useQuery({
    queryKey: ["employees", { status: "ACTIVE" }],
    queryFn: async () => {
      try {
        const params = new URLSearchParams({ status: "ACTIVE" });
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BASE_API_URL}user?${params.toString()}`,
        );

        let rawData = response.data;

        if (!Array.isArray(rawData)) {
          console.warn("Employee data is not an array:", rawData);
          rawData = [];
        }

        const employees: UserPublicInfoDto[] = rawData.map(
          mapUserDtoToPublicInfo,
        );

        return employees;
      } catch (error) {
        console.error("Error fetching employees:", error);
        toast({
          title: "Error",
          description: "Failed to load employees",
          variant: "destructive",
        });
        return [];
      }
    },
    enabled,
  });
}
